<template>
  <div class="cps-main-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>礼包管理</el-breadcrumb-item>
      <el-breadcrumb-item>扶持发放记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <div class="page-content">
    <el-row @keyup.enter.native="loadData(1)">
      <el-input v-model="queryField.userId" size="small" placeholder="玩家id"></el-input>
      <el-input v-model="queryField.userName" size="small" placeholder="玩家账号"></el-input>
      <el-input v-model="queryField.serverName" size="small" placeholder="区服名称"></el-input>
      <el-input v-model="queryField.roleName" size="small" placeholder="角色名称"></el-input>

      <el-date-picker
              size="small"
              v-model="queryField.start_time"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="开始日期">
      </el-date-picker>
      <el-date-picker
              size="small"
              v-model="queryField.end_time"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="结束日期">
      </el-date-picker>

      <el-select v-model="queryField.status" size="small" placeholder="发放结果">
        <el-option label="发放结果" value=""/>
        <el-option label="发放成功" value="1"/>
        <el-option label="发放失败" value="2"/>
      </el-select>

      <el-button  type="primary" icon="el-icon-search" size="small" @click="loadData(1)">查询</el-button>
    </el-row>
    <el-table class="cps-table-data"
              :data="tableData" size="small"
              border
              :height="height"
              style="width: 100%">
      <el-table-column
          prop="user_id"
          label="账号id"
          width="80">
      </el-table-column>
      <el-table-column
          prop="user_name"
          label="玩家账号"
          width="120">
      </el-table-column>
      <el-table-column
              prop="game_name"
              label="游戏名称"
              width="100">
      </el-table-column>
      <el-table-column
          prop="role_name"
          label="角色名字"
          width="140">
      </el-table-column>
      <el-table-column
          prop="server_name"
          label="区服名称"
          width="140">
      </el-table-column>
      <el-table-column
            prop="recharge_point"
            label="扶持内容"
            width="140">
      </el-table-column>

      <el-table-column
              prop="price"
              label="价值"
              width="100">
      </el-table-column>

      <el-table-column
              prop="submit_time"
              label="发放时间"
              width="140">
      </el-table-column>
      <el-table-column
              prop="submit_admin_id"
              label="发放人"
              width="80">
      </el-table-column>
      <el-table-column
              prop="status"
              label="发放结果"
              width="70">
          <template slot-scope="scope">
            {{scope.row.status === 1 ? '成功' : '失败'}}
          </template>
      </el-table-column>

      <el-table-column
              prop="msg"
              label="发放失败原因"
              width="200">
      </el-table-column>

    </el-table>
    <el-pagination  class="cps-table-data"
        @current-change="loadData"
        background
        :page-size="15"
        layout="total, prev, pager, next"
        :total="total">
    </el-pagination>
    </div>

    <el-drawer
            :visible.sync="showItemList"
            direction="rtl"
            size="650px">
      <el-table :data="itemData" class="drawer-table-data" border >
        <el-table-column property="id" label="ID" width="80"></el-table-column>
        <el-table-column property="recharge_point" label="物品名称" width="160"></el-table-column>
        <el-table-column property="price" label="价值" width="160"></el-table-column>
        <el-table-column label="操作"  width="200">
          <template slot-scope="scope">
            <el-button type="text"  size="small" @click="doSend(scope.row)">确认发放</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>

  </div>
</template>
<script>
import {getSupportRoleList, getPageButtons, supportLog} from "@/api/request";
export default {
  name: 'gameRole',
  data() {
    return {
      tableData: [],
      queryField: {
        roleCode:'',
        roleName:'',
        serverCode:'',
        serverName:'',
        userId: '',
        userName: '',
        start_time: '',
        end_time: '',
        status: '1',
      },
      total: 0,
      height: window.innerHeight - 210,
      showSend: false,
      showItemList: false,
      itemData: [],
      selectedUser: {},
    };
  },
  mounted() {
    this.loadData(1);
    this.getPageButtons();
  },
  methods: {
    getPageButtons() {
      let path = this.$route.path.replace("/", "");
      getPageButtons(path).then(res => {
        if (res.data.success) {
          let menuCodes = res.data.data;
          this.showSend = menuCodes.includes("support_send");
        } else {
          this.$message.error(res.data.error.message);
        }
      });
    },
    loadData(index) {
      let params = {
        pageNo: index,
        pageSize: 15,
        params: {
          user_id: this.queryField.userId,
          user_name: this.queryField.userName,
          server_name: this.queryField.serverName,
          role_name: this.queryField.roleName,
          start_time: this.queryField.start_time,
          end_time: this.queryField.end_time,
          status: this.queryField.status
        }
      }
      supportLog(params).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total;
      })
    },
  }

}
</script>
<style lang="scss" scoped>
  .cps-main-page {
    .cps-table-data {
      td {
        .el-image {
          display: inherit;
        }
      }
    }

    /deep/.drawer-table-data {
      padding: 0 10px;
      thead {
        color: #2b2929;
        tr{
          th{
            background-color: #f5f5f5;
          }
        }
      }

      td {
        font-weight: 500;
        .cell{
          button{
            padding: 0;
          }
        }
      }
      .el-table__cell{
        padding: 8px 0;
      }

    }

  }
</style>

